import React from 'react';

export function lazyWithTiming(factory, label) {
  return React.lazy(async () => {
    const module = await factory();
    return module;
  });
}



